import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const switchSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.switch, {
        variants: {
            variant: {
                solid: {
                    control: {
                        bg: '{colors.gray.400}',
                    },
                },
            },
            size: {
                sm: {
                    root: {
                        '--switch-height': 'sizes.4.5',
                    },
                },
            },
        },
    }),
);
